import * as React from 'react'
import { DisplayContent, Plural, Singular } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import { Theme } from '../../../data/models/funnelOrder/theme'
import { AppState } from '../../../data/state'

interface DaysSummaryProps {
  days: number
  locations: number
  loading: boolean
  contentKey: string
  fallback?: string
  destination: any
  theme: Theme

  getDestination(dest: any): string | JSX.Element
}

const DaysSummary: React.FC<DaysSummaryProps> = props => {
  const {
    days,
    locations,
    loading,
    contentKey,
    fallback = 'city break',
    getDestination,
    destination,
  } = props
  const loadingClass = loading ? 'is-loading' : ''
  return (
    <ListItem>
      <span className={loadingClass}>
        <DisplayContent
          contentKey="days-summary"
          vars={{ days: days.toString() }}
          addNode={false}
          plural={days > 1}
        >
          <Singular>{`${days} day`}</Singular>
          <Plural>{`${days} days`}</Plural>
        </DisplayContent>
        {props.theme === Theme.multiFly ? (
          <>
            ,&nbsp;
            <DisplayContent
              contentKey="cities-summary"
              vars={{ locations: locations.toString() }}
              plural={locations > 1}
            >
              <Singular>{`${locations} city`}</Singular>
              <Plural>{`${locations} cities`}</Plural>
            </DisplayContent>
          </>
        ) : (
          <>
            &nbsp;
            <DisplayContent contentKey={contentKey} addNode={false}>
              {fallback}
            </DisplayContent>
          </>
        )}
        {![Theme.incontrol, Theme.train].includes(props.theme) ? (
          <>&nbsp;({getDestination(destination)})</>
        ) : null}
      </span>
    </ListItem>
  )
}

export default connect((state: AppState) => ({
  days: state.funnelOrder.days,
  locations: state.funnelOrder.locations,
  loading: state.contentEngine.loading,
  theme: state.funnelOrder.theme,
}))(DaysSummary)
